import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { IBusinessSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import useGetSelectOption from 'src/hooks/useGetSelectOption';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import removeNullUndefined from 'src/utils/removeNullUndefined';

import { buildCategoryOptions } from '../utils/bulidCategoryOptions';

export interface ISearchFormProps {
  onSearch: (data: IBusinessSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { t } = useTranslation();
  const { getUseYn, getLang } = useGetSelectOption();
  const { categoryStore } = useStores();

  const methods = useForm<IBusinessSFilter>({
    defaultValues: { categorySid: '', useYn: '', searchText: '' },
  });

  // categorySid: 최상위 카테고리 옵션
  // 최상위 카테고리 제외하고 2epth 이하 카테고리만 노출 select option
  const CTEGRY_SELECT_OPTIONS = useMemo(
    () => buildCategoryOptions(toJS(categoryStore.categoryTree)),
    [categoryStore.categoryTree],
  );

  // useYn: 사용 여부 옵션
  const USEYN = getUseYn();
  const LANG = getLang();

  // 검색 함수
  const onValid = (data: IBusinessSFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true}>
        <FormItem>
          <RHFSelect
            label={t('business.fields.category.name')}
            name="categorySid"
            options={CTEGRY_SELECT_OPTIONS}
          />
        </FormItem>
        <FormItem>
          <RHFSelect label={t('business.fields.useYn.name')} name="useYn" options={USEYN} />
        </FormItem>
        <FormItem>
          <RHFSelect label={t('business.fields.langCd.name')} name="langCd" options={LANG} />
        </FormItem>
        <FormItem size={2}>
          <RHFTextField label={t('business.fields.searchText.name')} name="searchText" />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
